import { connect } from 'react-redux';
import { compose } from 'redux'
import { withStyles } from '@material-ui/core';
import { createStructuredSelector } from 'reselect'

import { WaitingListTable as View } from './WaitingListTable'

import { isPartnerSelector, isLimitedDispatcherSelector } from 'reduxModules/selectors/UserSelectors'
import {
  isLoadingSelector,
  waitingPassengersSelector,
  waitingPassengersIsEmptySelector
} from 'reduxModules/selectors/RouteSelectors'

import { styles } from './styles'

const mapStateToProps = createStructuredSelector({
  waitingPassengers: waitingPassengersSelector,
  waitingPassengersIsEmpty: waitingPassengersIsEmptySelector,
  isLoading: isLoadingSelector,
  isLimitedDispatcher: isLimitedDispatcherSelector,
  isPartner: isPartnerSelector,
})

const enhance = compose(
  connect(mapStateToProps),
  withStyles(styles)
)

export const WaitingListTable = enhance(View)


// WEBPACK FOOTER //
// ./src/components/WaitingListTable/index.js